import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Select from "react-select";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import "datatables.net-responsive-dt/js/responsive.dataTables.js";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { API_URL } from "..";

const PayrollTable = () => {
  const navigate = useNavigate();
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [payrollData, setPayrollData] = useState([]);
  const tableRef = useRef(null);
  const dataTableRef = useRef(null);

  const monthOptions = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const yearOptions = Array.from({ length: 31 }, (_, i) => ({
    value: (2000 + i).toString(),
    label: (2000 + i).toString(),
  }));

  useEffect(() => {
    // Set default month and year to current date
    const currentDate = new Date();
    const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0");
    const currentYear = currentDate.getFullYear().toString();

    setSelectedMonth(monthOptions.find((option) => option.value === currentMonth));
    setSelectedYear(yearOptions.find((option) => option.value === currentYear));

    // Fetch initial payroll data
    fetchPayrollData(currentMonth, currentYear);

    // Cleanup DataTable on component unmount
    return () => {
      if (dataTableRef.current) {
        dataTableRef.current.destroy();
        dataTableRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    // Initialize or update DataTable when payrollData changes
    if (tableRef.current) {
      // Destroy existing DataTable instance if it exists
      if (dataTableRef.current) {
        dataTableRef.current.destroy();
        dataTableRef.current = null;
      }

      // Only initialize DataTable if there is data
      if (payrollData.length > 0) {
        dataTableRef.current = $(tableRef.current).DataTable({
          responsive: true,
          pageLength: 10,
          searching: true,
          ordering: true,
          data: payrollData,
          columns: [
            {
              data: null,
              render: (data) =>
                `
                <div class="d-flex align-items-center gap-2">
                  <img src="${data.image}" alt="${data.name}" class="rounded-circle" style="width: 40px; height: 40px" />
                  <span>${data.name}</span>
                </div>
              `,
            },
            { data: "job_title" },
            { data: "payroll_period" },
            { data: "present_days" },
            { data: "absent_days" },
            { data: "net_salary", render: (data) => `$${parseFloat(data).toFixed(2)}` },
            {
              data: null,
              render: (data) =>
                `
                <div class="d-flex gap-2">
                  <button class="btn btn-sm btn-primary edit-button" data-id="${data.emp_id}" title="Edit">
                    <i class="bi bi-pencil"></i> Edit
                  </button>
                  <button class="btn btn-sm btn-info preview-button" data-id="${data.emp_id}" title="Preview">
                    <i class="bi bi-eye"></i> Preview
                  </button>
                </div>
              `,
            },
          ],
          columnDefs: [{ orderable: false, targets: -1 }],
        });

        // Attach click handlers for edit and preview buttons
        $(tableRef.current).on("click", ".edit-button", function () {
          const id = $(this).data("id");
          navigate(`/payroll/edit/${selectedMonth.value}/${selectedYear.value}/${id}`);
        });

        $(tableRef.current).on("click", ".preview-button", function () {
          const id = $(this).data("id");
          navigate(`/payroll/view/${selectedMonth.value}/${selectedYear.value}/${id}`);
        });
      }
    }
  }, [payrollData, navigate]);

  const fetchPayrollData = async (month, year) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.id) {
      console.error("User not found in localStorage");
      setPayrollData([]);
      return;
    }

    const headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    const bodyContent = JSON.stringify({
      org_id: user.id,
      month: month,
      year: year,
      type: "all",
      emp_ids: [],
    });

    try {
      const response = await fetch(`${API_URL}/api/payroll/generate`, {
        method: "POST",
        body: bodyContent,
        headers: headersList,
      });

      const data = await response.json();
      if (response.status === 200) {
        setPayrollData(data.payroll || []);
      } else {
        console.error("Failed to fetch payroll data:", data);
        setPayrollData([]);
      }
    } catch (error) {
      console.error("Error fetching payroll data:", error.message);
      setPayrollData([]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedMonth && selectedYear) {
      fetchPayrollData(selectedMonth.value, selectedYear.value);
    }
  };

  const handleMonthChange = (selected) => {
    setSelectedMonth(selected);
  };

  const handleYearChange = (selected) => {
    setSelectedYear(selected);
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Payroll Table" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="row mb-20">
            <form onSubmit={handleSubmit}>
              <div className="row align-items-end">
                <div className="col-md-4">
                  <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                    Select Month
                  </label>
                  <Select
                    options={monthOptions}
                    value={selectedMonth}
                    onChange={handleMonthChange}
                    placeholder="Select Month"
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                    Select Year
                  </label>
                  <Select
                    options={yearOptions}
                    value={selectedYear}
                    onChange={handleYearChange}
                    placeholder="Select Year"
                  />
                </div>
                <div className="col-md-4">
                  <button
                    type="submit"
                    className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                  >
                    Filter
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="table-responsive">
            <table ref={tableRef} className="table table-hover table-bordered w-100">
              <thead>
                <tr>
                  <th>Employee</th>
                  <th>Job Title</th>
                  <th>Payroll Period</th>
                  <th>Present Days</th>
                  <th>Absent Days</th>
                  <th>Net Salary</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default PayrollTable;